const baseUrl = 'https://garbagedisposal.dysbcfertilizer.cn/index.php';
export {
	baseUrl,
}